import { formatTokenAmount, shortenAddress } from '../lib/formatters.js';
import type { TokenSymbol } from '@cryptopay/core';

export interface BalanceProps {
  readonly address: string;
  readonly email: string;
  readonly balance: bigint;
  readonly decimals: number;
  readonly symbol: TokenSymbol;
  readonly loading?: boolean;
  readonly onRefresh?: () => void;
}

export function Balance({
  address,
  email,
  balance,
  decimals,
  symbol,
  loading,
  onRefresh,
}: BalanceProps) {
  return (
    <div className="cp-card" aria-label="balance-card">
      <div className="cp-row">
        <div>
          <div className="cp-mono" style={{ fontSize: 12, color: 'var(--muted)' }}>
            {email}
          </div>
          <div className="cp-mono" title={address}>
            {shortenAddress(address)}
          </div>
        </div>
        <button
          className="cp-button cp-secondary"
          style={{ width: 'auto', padding: '6px 12px' }}
          onClick={onRefresh}
          disabled={loading}
          aria-label="refresh-balance"
        >
          {loading ? '…' : '↻'}
        </button>
      </div>
      <div className="cp-row" style={{ marginTop: 12 }}>
        <span style={{ color: 'var(--muted)' }}>Bakiye</span>
        <span className="cp-mono cp-receipt-amount">
          {formatTokenAmount(balance, decimals)} {symbol}
        </span>
      </div>
    </div>
  );
}
